import { CSSProperties, FC, useEffect, useState } from "react";
import useDebounce from "Hooks/useDebounce";
import { Icon } from "../Icon";
import { InputWrapper } from "./styles";

export interface ISearchInput {
  defaultValue?: string;
  inputPlaceholder?: string;
  customClassName?: string;
  inputClassName?: string | null;
  delay?: number;
  style?: CSSProperties;
  noDebounceValue?: string;
  withDebounce?: boolean;
  setSearch: (value: string) => void;
  setSearchLoading?: (value: boolean) => void;
}

const SearchInput: FC<ISearchInput> = ({
  defaultValue,
  inputPlaceholder,
  customClassName,
  inputClassName,
  delay,
  style,
  noDebounceValue,
  withDebounce = true,
  setSearch,
  setSearchLoading,
}) => {
  const [focus, setFocus] = useState(false);
  const [inputValue, setInputValue] = useState('');

  const {
    debouncedValue,
    debouncedLoading,
  } = useDebounce(inputValue, delay || 600);

  const handleChangeSearch = (event: any) => {
    if (withDebounce) {
      setInputValue(event.target.value);
    } else {
      setSearch(event.target.value);
    }
  }

  useEffect(() => {
    if (defaultValue) {
      setInputValue(defaultValue);
    }
  }, [defaultValue]);

  useEffect(() => {
    if (withDebounce) {
      setSearch(debouncedValue);
      if (setSearchLoading) {
        setSearchLoading(debouncedLoading);
      }
    }
  }, [debouncedValue, debouncedLoading, withDebounce]);

  return (
    <InputWrapper className={customClassName}>
      <span className="icon">
        <Icon
          icon="buscar"
          color={focus ? 'primary' : 'cinzaPadrao'}
          size="xxs"
        />
      </span>
      <input
        type="text"
        value={withDebounce ? inputValue : noDebounceValue || ''}
        onChange={(e) => {
          handleChangeSearch(e);
        }}
        onFocus={(e) => setFocus(!!e)}
        onBlur={() => setFocus(false)}
        className={`input ${inputClassName ? inputClassName : ''}`}
        placeholder={inputPlaceholder}
        style={style}
      />
    </InputWrapper>
  )
}

export default SearchInput;
